const en = {
  title: "File Management",
  folder: "Folder",
  fileName: "File Name",
  mimeType: "File Type",
  updatedBy: "Last Updater",
  updatedAt: "Last Update Date",
  folderType: {
    INSTALLATION: "Installation",
    RETRIEVAL: "Retrieval",
    ASSIGNMENT: "Assignment",
    RETURN: "Return",
    RECEIVING: "Receiving",
    INITIAL_SETUP: "Initial Setup",
    INVENTORY: "Inventory",
    REPAIR: "Repair",
    REPLACEMENT: "Replacement",
    DISPOSAL: "Disposal",
    DOCUMENT: "Document",
  },
  upload: {
    button: "Upload File",
    title: "Upload File",
    description: "Upload files related to this device",
    selectFile: "Select File",
    selectedFile: "Selected File",
    placeholder: "Enter file name",
    originalFileName: "Original file name",
    helpText: "Supported formats: JPEG, PNG, GIF, PDF (Max 100MB)",
    validationError: "File is invalid",
    submit: "Upload",
    uploading: "Uploading...",
    success: "File uploaded successfully",
    error: {
      fileNameRequired: "File name is required.",
      invalidCharacters: "File name contains invalid characters.",
      fileNameTooLong:
        "File name is too long. Maximum {{maxLength}} characters allowed.",
      missingExtension: "File name must have an extension.",
      extensionMismatch: "File extension does not match the original file.",
      invalidFileType:
        'File type "{{mimeType}}" is not supported. Only images (JPEG, PNG, GIF) and PDF files are allowed.',
      fileSizeExceeded:
        "File size ({{actualSize}}MB) exceeds the maximum allowed size of {{maxSize}}MB.",
      unknown: "File validation failed.",
    },
  },
  rename: {
    title: "Rename File",
    description: "Change the file name",
    newFileName: "New File Name",
    placeholder: "Enter file name",
    submit: "Rename",
    updating: "Updating...",
    success: "File renamed successfully",
    error: "Failed to rename file",
  },
  delete: {
    title: "Delete File",
    description:
      'Are you sure you want to delete "{{fileName}}"? This action cannot be undone.',
    submit: "Delete",
    deleting: "Deleting...",
    success: "File deleted successfully",
    error: "Failed to delete file",
  },
  actions: {
    preview: "Preview",
    rename: "Rename",
    delete: "Delete",
    openFolder: "Open {{folderName}} folder",
    cancel: "Cancel",
  },
  download: {
    fallback: "Failed to download file. Opening in browser.",
  },
};

export default en;
